import BaseHead from "../templates/BaseHead";
import { getSubdomain } from "../../utils/getSubdomain";
import STUtils from "../../assets/styles/utility.module.scss";
import ForumCategory from "../organisms/ForumCategoryPage";
import BottomNavigationBar from "../organisms/BottomNavigationBar";
import STForumCategory from "../../assets/styles/organisms/forumCategory.module.scss";

const ForumCategoryPage = () => {
  const subdomain = getSubdomain(window.location.hostname);
  return (
    <BaseHead
      title="カテゴリ詳細"
      login={true}
      subdomain={subdomain}
      hasNavigationBar={true}
      hasBackground
    >
      <div
        className={`${STUtils.container_large} ${STForumCategory.custom_container}`}
      >
        <ForumCategory />
        <div style={{ marginBottom: "24px" }}>
          <BottomNavigationBar />
        </div>
      </div>
    </BaseHead>
  );
};

export default ForumCategoryPage;
